import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Page} from '@uofu-uss/angular-util';
import {ThirdPartyLicense} from './third-party-license.service';

@Injectable({
  providedIn: 'root'
})
export class ThirdPartyLicenseDataService {

  public static readonly baseUrl = '/api/third-party-license';

  private readonly http = inject(HttpClient);

  search(vendorName: string, name: string): Observable<Page<ThirdPartyLicense>> {
    const params = new HttpParams().appendAll({vendorName, name});
    return this.http.get<Page<ThirdPartyLicense>>(`${ThirdPartyLicenseDataService.baseUrl}/`, {params});
  }
}
